import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getProductos } from '../api/productos';
import PosterGrid from '../components/PosterGrid';
import CategorySwitcher from '../components/CategorySwitcher';
import GenderSwitcher from '../components/GenderSwitcher';
import logo from '../logo.jpg';
import useSEO from '../hooks/useSEO';
import './Home.css';

// /coleccion (sin parámetro) sigue mostrando Bautismo por defecto, sin
// tocar su comportamiento actual -- pero cada categoría también vive en
// su propia URL (/coleccion/bautismo, /coleccion/comunion), cada una con
// su propio título/H1/intro. Antes todo el filtrado era estado de React
// puro, invisible para Google: no había ninguna página indexable
// específica para "estampitas bautismo" ni "estampitas comunión".
const CATEGORY_CONTENT = {
  bautismo: {
    label: 'Bautismo',
    title: 'Estampitas para Bautismo Personalizadas | MiEstampita',
    description:
      'Estampitas de bautismo personalizadas, pintadas a mano en acuarela. Elegí tu diseño, agregá el nombre, la fecha y la oración, y recibilas en todo Uruguay.',
    h1: 'Estampitas para Bautismo',
    intro:
      'Estampitas para bautismo pintadas a mano en acuarela, pensadas para acompañar ese primer sacramento con un recuerdo delicado y personal. Cada diseño se personaliza con el nombre del bebé, la fecha de la ceremonia y una oración a elección, lista para repartir entre padrinos, familiares e invitados. Elegí entre nuestros diseños para varón o niña y recibila en cualquier punto de Uruguay.',
  },
  comunion: {
    label: 'Comunion',
    title: 'Estampitas para Primera Comunión Personalizadas | MiEstampita',
    description:
      'Estampitas de primera comunión personalizadas, pintadas a mano en acuarela. Elegí tu diseño, agregá el nombre, la fecha y la oración, y recibilas en todo Uruguay.',
    h1: 'Estampitas para Primera Comunión',
    intro:
      'Estampitas para primera comunión ilustradas en acuarela, pensadas para guardar el recuerdo de ese día tan especial. Se personalizan con el nombre del niño o niña que hace la comunión, la fecha y la oración que elijas, para tener un souvenir único para cada invitado. Elegí tu diseño favorito y te lo hacemos llegar a cualquier parte de Uruguay.',
  },
};

const Home = () => {
  const { categoria } = useParams();
  const categoryContent = CATEGORY_CONTENT[categoria] || null;

  const [selectedCategory, setSelectedCategory] = useState(categoryContent?.label || 'Bautismo');
  const [selectedGender, setSelectedGender] = useState(null);
  const [products, setProducts] = useState([]);
  const [loadState, setLoadState] = useState('loading');

  // Si la categoría viene de la URL, manda por sobre el estado local (ej.
  // al navegar de /coleccion/bautismo a /coleccion/comunion por link
  // directo, no por el switcher).
  useEffect(() => {
    if (categoryContent) setSelectedCategory(categoryContent.label);
  }, [categoryContent]);

  useSEO({
    title: categoryContent?.title || 'Colección de Estampitas para Bautismo y Primera Comunión | MiEstampita',
    description:
      categoryContent?.description ||
      'Explorá nuestra colección de estampitas de bautismo y primera comunión personalizadas, hechas a mano en Montevideo, Uruguay, con envíos a Punta del Este y todo el país.',
    path: categoria ? `/coleccion/${categoria}` : '/coleccion',
  });

  const loadProducts = () => {
    setLoadState('loading');
    getProductos()
      .then((data) => {
        setProducts(data);
        setLoadState('ready');
      })
      .catch(() => setLoadState('error'));
  };

  useEffect(() => {
    loadProducts();
  }, []);

  const currentStamps = products.filter(
    (stamp) =>
      stamp.category === selectedCategory &&
      (!selectedGender || !stamp.genre || stamp.genre === selectedGender)
  );

  return (
    <div className="home-page">
      <div className="logo-wrapper">
        <Link to="/">
          <img src={logo} alt="MiEstampita Logo" className="logo" />
        </Link>
      </div>
      <div className="home-wrapper">
        <h1 className="category-switcher__title">
          {categoryContent?.h1 || 'Estampitas para Bautismo y Primera Comunión'}
        </h1>
        <p className="collection-hint">
          {categoryContent?.intro ||
            'Estampitas personalizadas para bautismo y primera comunión, ilustradas y pintadas a mano en acuarela. Elegí el diseño que más te guste, personalizalo con el nombre, la fecha y la oración que quieras, y recibilo listo para repartir entre tus invitados.'}
        </p>
        <p className="collection-hint">Dale click al diseño que más te guste para empezar a diseñar tu estampita.</p>
        <GenderSwitcher selectedGender={selectedGender} onChange={setSelectedGender} />
        <CategorySwitcher selectedCategory={selectedCategory} />

        {loadState === 'loading' && <p className="collection-hint">Cargando estampitas...</p>}
        {loadState === 'error' && (
          <p className="collection-hint">
            No pudimos cargar el catálogo.{' '}
            <button type="button" className="retry-link" onClick={loadProducts}>
              Reintentar
            </button>
          </p>
        )}
        {loadState === 'ready' && <PosterGrid stamps={currentStamps} />}
      </div>
    </div>
  );
};

export default Home;
